import { graphql } from 'gatsby';
import * as React from 'react';
import { RecordingPreviewData } from '../types';
import { recordingRawDataToPreviewData } from '../utils/frontend';
import RecordingCardAlt, { RecordingCardAltProps } from './RecordingCardAlt';

interface Props {
  data: Queries.RecordingCardDataFragment | RecordingPreviewData;
  className?: string;
  titleAs?: RecordingCardAltProps['titleAs'];
}

export default function RecordingCard({ data, className = '', titleAs = undefined }: Props) {
  const recording: RecordingPreviewData | null = React.useMemo(() => {
    if (!data) {
      return null;
    }

    if (!('recordingSettings' in data)) {
      return data;
    }

    return recordingRawDataToPreviewData(data as Queries.RecordingCardDataFragment);
  }, [data]);

  if (!recording) {
    return null;
  }

  return <RecordingCardAlt recording={recording} className={className} titleAs={titleAs} />;
}

export const RecordingCardDataFragment = graphql`
  fragment RecordingCardData on WpRecording {
    id: databaseId
    title
    uri
    date
    recordingSettings {
      userFriendlyTitle
      recordist {
        ... on WpRecordist {
          graphqlId: id
          id: databaseId
          title
          uri
        }
      }
      recordists {
        ... on WpRecordist {
          graphqlId: id
          id: databaseId
          title
          uri
        }
      }
      audioUrl
      audio {
        mediaDetails {
          length
        }
      }
      isLivestream
    }
    featuredImage {
      node {
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: DOMINANT_COLOR, width: 512)
          }
        }
      }
    }
  }
`;
